/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Tab_SocialInputs */

const cs_property_tab_social = /** @type {(inputs: Property_Tab_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociální sítě`)
};

const en_property_tab_social = /** @type {(inputs: Property_Tab_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social`)
};

/**
* | output |
* | --- |
* | "Social" |
*
* @param {Property_Tab_SocialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tab_social = /** @type {((inputs?: Property_Tab_SocialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Tab_SocialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tab_social(inputs)
	return cs_property_tab_social(inputs)
});